// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-documents-item-boucu{display:grid;grid-gap:16px;grid-template-columns:48px 1fr}.components-products-documents-item-boucu:not(:last-child){margin-bottom:24px}.components-products-documents-link-brqbh{text-decoration:none}.components-products-documents-link-brqbh:hover{text-decoration:underline}.components-products-documents-size-broxm{color:#777;font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "components-products-documents-item-boucu",
	"link": "components-products-documents-link-brqbh",
	"size": "components-products-documents-size-broxm"
};
module.exports = ___CSS_LOADER_EXPORT___;
